module.exports = __webpack_public_path__ + "assets/img/bg-female-4d2caa36.png";